import { useEffect } from "react";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const TableRowNoResults = ({ data, text = "-- NO RESULTS RETURNED --" }) => {
  useEffect(() => {}, []);

  return (
    <>
      {data != null && data.length === 0 && (
        <TableRow>
          <TableCell colSpan={10}>{text}</TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TableRowNoResults;
